let config;

switch (process.env.REACT_APP_NODE_ENV) {
  case "production":
    config = require("./environments/prod.environment");
    break;
  case "test":
    config = require("./environments/test.environment");
    break;
  case "development":
  default:
    config = require("./environments/dev.environment");
}

module.exports = config;